import React from 'react';
export const Banner10DataSource = {
  wrapper: { className: 'banner1' },
  BannerAnim: {
    children: [
      {
        name: 'elem0',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg0 lai6c9kkhad-editor_css' },
        title: {
          className: 'banner1-title lai6cb3imwk-editor_css',
          children:
            'https://cdn.staticaly.com/gh/powerli2002/project-img@main/图片1.9bky1zh67t8.png',
        },
        content: {
          className: 'banner1-content le4cpmrruik-editor_css',
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <blockquote>
                                  高危环境多模感知救援机器人
                                </blockquote>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          ),
        },
        button: {
          className: 'banner1-button lai6bgx0ao-editor_css',
          children: 'Learn More',
        },
      },
      {
        name: 'elem1',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg1 lai6dd265p-editor_css' },
        title: {
          className: 'banner1-title',
          children:
            'https://cdn.staticaly.com/gh/powerli2002/project-img@main/图片1.9bky1zh67t8.png',
        },
        content: {
          className: 'banner1-content le4d14l7xd-editor_css',
          children: (
            <span>
              <span>
                <span>
                  <p> 高危环境多模感知救援机器人</p>
                </span>
              </span>
            </span>
          ),
        },
        button: {
          className: 'banner1-button lai6c6373pu-editor_css',
          children: 'Learn More',
        },
      },
      {
        name: 'elem2',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg1 lai6bzmc0nf-editor_css' },
        title: {
          className: 'banner1-title le4c2o7cbdf-editor_css',
          children:
            'https://cdn.staticaly.com/gh/powerli2002/project-img@main/图片1.9bky1zh67t8.png',
        },
        content: {
          className: 'banner1-content le4d1h4ovzq-editor_css',
          children: (
            <span>
              <span>
                <p> 高危环境多模感知救援机器人</p>
              </span>
            </span>
          ),
        },
        button: {
          className: 'banner1-button lai6c35p1h-editor_css',
          children: 'Learn More',
        },
      },
    ],
  },
};
export const Banner20DataSource = {
  wrapper: { className: 'banner2' },
  BannerAnim: {
    children: [
      {
        name: 'elem0',
        BannerElement: { className: 'banner-user-elem' },
        page: { className: 'home-page banner2-page' },
        textWrapper: { className: 'banner2-text-wrapper' },
        bg: { className: 'bg bg0 le4cc71uaif-editor_css' },
        title: {
          className: 'banner2-title le4d36ciklc-editor_css',
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <p>全景巡回地图建模</p>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          ),
        },
        content: {
          className: 'banner2-content',
          children: (
            <span>
              <p>
                本SLAM监测技术达到差异性协作，精准化建图，实现双平台运行，可在安卓端和PC端使用。
              </p>
            </span>
          ),
        },
        button: {
          className: 'banner2-button',
          children: 'Learn More',
          type: 'primary',
          href: 'https://reliable-madeleine-39555e.netlify.app/',
          target: '_blank',
        },
      },
    ],
  },
};
export const Banner21DataSource = {
  wrapper: { className: 'banner2' },
  BannerAnim: {
    children: [
      {
        name: 'elem0',
        BannerElement: { className: 'banner-user-elem' },
        page: { className: 'home-page banner2-page le4d9y8pqu-editor_css' },
        textWrapper: { className: 'banner2-text-wrapper' },
        bg: { className: 'bg bg0 le4da1ccj1-editor_css' },
        title: {
          className: 'banner2-title le4d9wt2ut-editor_css',
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <p>数据大屏精准施救</p>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          ),
        },
        content: {
          className: 'banner2-content',
          children: (
            <span>
              <span>
                <p>实时数据，精准建议，快速救援</p>
              </span>
            </span>
          ),
        },
        button: {
          className: 'banner2-button',
          children: 'Learn More',
          type: 'primary',
          href: 'https://tiny-cendol-a2c077.netlify.app/',
          target: '_blank',
        },
      },
    ],
  },
};
export const Content40DataSource = {
  wrapper: { className: 'home-page-wrapper content4-wrapper' },
  page: { className: 'home-page content4 le5bihmlth-editor_css' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <span>
              <span>
                <p>智能救援车提供高效准确的地图构建方案</p>
              </span>
            </span>
          </span>
        ),
        className: 'title-h1 le5bj8ol9s6-editor_css',
      },
      {
        name: 'content',
        className: 'title-content content4-title-content le5bj8427h-editor_css',
        children: (
          <span>
            <p>快速建模，实时场景</p>
          </span>
        ),
      },
    ],
  },
  video: {
    className: 'content4-video',
    children: {
      video: 'http://storage.live.com/items/B1E8CB8075293FF!687:/2.mp4',
      image:
        'https://cdn.staticaly.com/gh/powerli2002/project-img@main/主地图.6soeqkpron00.png',
    },
  },
};
export const Feature30DataSource = {
  wrapper: { className: 'home-page-wrapper content3-wrapper' },
  page: { className: 'home-page content3 le57ar4vj3k-editor_css' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <span>
              <p>自主研发可用于高危环境救援机器人</p>
            </span>
          </span>
        ),
        className: 'title-h1',
      },
      {
        name: 'content',
        className: 'title-content',
        children: (
          <span>
            <p>为工人安全保驾护航</p>
          </span>
        ),
      },
    ],
  },
  block: {
    className: 'content3-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/ScHBSdwpTkAHZkJ.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <span>
                <p>SLAM算法构建室内、外实时地图</p>
              </span>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <span>
                <p>
                  本SLAM监测技术达到差异性协作，精准化建图，实现双平台运行，可在安卓端和PC端使用。
                </p>
              </span>
            ),
          },
        },
      },
      {
        name: 'block1',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/NKBELAOuuKbofDD.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <span>
                <p>unity引擎</p>
                <p>仿真环境构建</p>
              </span>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <span>
                <p>
                  采用unity引擎开发，从全新的视角进行工业园区从日常巡检到火灾爆炸等事故现场的模拟。
                </p>
              </span>
            ),
          },
        },
      },
      {
        name: 'block2',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/xMSBjgxBhKfyMWX.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>Yolov5深度学习平台智能检测</p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <span>
                <span>
                  <p>
                    基于深度学习的yolov5模型，可以实现对八十种常见物体和生物类别的<span
                    >
                      识别功能
                    </span>
                  </p>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block3',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/MNdlBNhmDBLuzqp.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <span>
                <p>声音、图像、温度多维监测</p>
              </span>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <span>
                <p>
                  应用SYN6288芯片实现<span>播报语音，</span>
                  <span>基于深度学习的yolov5模型实现对人体和目标的识别，</span>
                  <span>选用机械臂搭载测温传感器进行接触式测量温度。</span>
                </p>
              </span>
            ),
          },
        },
      },
      {
        name: 'block4',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/UsUmoBRyLvkIQeO.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <span>
                <p>A_star路径规划算法</p>
              </span>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <span>
                <p>
                  利用栅格地图法，能够表示空间环境中的更多特征，尽可能形象的反映出了环境的真实状态。结合Dijkstra算法与BFS算法的优点，得到A*算法，通过评估得到最好的位置，从这个位置进行搜索直到目标。
                </p>
              </span>
            ),
          },
        },
      },
      {
        name: 'block5',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/ipwaQLBLflRfUrg.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <span>
                <span>
                  <span>
                    <p>网站赋能，数据大屏精准施救</p>
                  </span>
                </span>
              </span>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <span>
                <p>
                  室内外建模可视化地图，日常监控与救援大屏双网站，为救援与维护工作赋能。
                </p>
              </span>
            ),
          },
        },
      },
    ],
  },
};
export const Feature10DataSource = {
  wrapper: { className: 'home-page-wrapper content1-wrapper' },
  OverPack: { className: 'home-page content1', playScale: 0.3 },
  imgWrapper: { className: 'content1-img', md: 10, xs: 24 },
  img: {
    children:
      'https://cdn.staticaly.com/gh/powerli2002/project-img@main/QQ图片20221022151659.6du5656x78w0.webp',
  },
  textWrapper: { className: 'content1-text', md: 14, xs: 24 },
  title: {
    className: 'content1-title',
    children: (
      <span>
        <span>
          <p>基于SLAM的室内外场景建模</p>
        </span>
      </span>
    ),
  },
  content: {
    className: 'content1-content',
    children: (
      <span>
        <span>
          <span>
            <p>
              通过对小车加装摄像头，将视频信息及时反馈，并通过接收设备对传输回的视频进<span
              >
                行 SLAM 构建出实时的陌生障碍环境，
              </span>
              <span>
                选择立体摄像搭配 wifi
                模块连接终端，反馈实时数据。采用超声波和红外避障。
              </span>
            </p>
            <p>
              <span>创新性地实现了较高精度的实时全景巡回地图。</span>
              <span>对区域救援排险信息的实时动态监测。</span>
              <span>PC，Android，图像识别，大数据，走航监测 多维赋能。</span>
            </p>
          </span>
        </span>
      </span>
    ),
  },
};
export const Feature20DataSource = {
  wrapper: { className: 'home-page-wrapper content2-wrapper' },
  OverPack: { className: 'home-page content2', playScale: 0.3 },
  imgWrapper: {
    className: 'content2-img le4e3xgf25-editor_css',
    md: 10,
    xs: 24,
  },
  img: {
    children:
      'https://cdn.staticaly.com/gh/powerli2002/project-img@main/processed2.l26ta646vhc.webp',
  },
  textWrapper: {
    className: 'content2-text le4e41i6baa-editor_css',
    md: 14,
    xs: 24,
  },
  title: {
    className: 'content2-title',
    children: (
      <span>
        <p>基于yolov5的人体目标检测</p>
      </span>
    ),
  },
  content: {
    className: 'content2-content',
    children: (
      <span>
        <p>
          通过大型数据集训练的模型，人体目标检测准确率达到平均百分之九十以上，图像实时回传，发现人体即报告，搜救人员即可迅速响应。
        </p>
      </span>
    ),
  },
};
export const Feature11DataSource = {
  wrapper: { className: 'home-page-wrapper content1-wrapper' },
  OverPack: { className: 'home-page content1', playScale: 0.3 },
  imgWrapper: { className: 'content1-img', md: 10, xs: 24 },
  img: {
    children:
      'https://cdn.staticaly.com/gh/powerli2002/project-img@main/图片1.49qa8hk3dta0.png',
    className: 'le56gmg6e8l-editor_css',
  },
  textWrapper: { className: 'content1-text', md: 14, xs: 24 },
  title: {
    className: 'content1-title',
    children: (
      <span>
        <p>声音、图像、温度多模感知</p>
      </span>
    ),
  },
  content: {
    className: 'content1-content',
    children: (
      <span>
        <p>
          小车行进过程当中，我们可以远程控制小车使其播报语音，灾后情况可使被困人员发现小车的到达，缩短救援时间。
        </p>
        <p>
          图像识别可实时捕捉现场设备、人员的图像，从而精准确定设备安全状况和待救援人员情况。
        </p>
        <p>
          温度检测选用机械臂搭载测温传感器进行接触式测量，该方式使得对于温度的把控更加精准，便于及时发现问题，或在事故发生后迅速判断故障原因等。
        </p>
      </span>
    ),
  },
};
export const Feature21DataSource = {
  wrapper: { className: 'home-page-wrapper content2-wrapper' },
  OverPack: { className: 'home-page content2', playScale: 0.3 },
  imgWrapper: { className: 'content2-img', md: 10, xs: 24 },
  img: {
    children:
      'https://cdn.staticaly.com/gh/powerli2002/project-img@main/图片2.2wpeyiar8m80.png',
  },
  textWrapper: { className: 'content2-text', md: 14, xs: 24 },
  title: {
    className: 'content2-title',
    children: (
      <span>
        <p>仿真环境构建</p>
      </span>
    ),
  },
  content: {
    className: 'content2-content',
    children: (
      <span>
        <span>
          <span>
            <p>
              采用unity引擎开发，从全新的视角进行工业园区从日常巡检到火灾爆炸等事故现场的模拟。<span
              >
                BIM建筑设计软件+国内某大型发电厂为模型 三维可视化信息模型。
              </span>
            </p>
            <p>
              <br />
            </p>
            <p>
              通过优化仿真与原始的紧急救援方案进行比较，总结灾情控制以及人员搜救的关键因素，归纳油罐、变压器、温度场、人员疏散口的设置对应急救援的影响，为实际应用奠基。
            </p>
          </span>
        </span>
      </span>
    ),
  },
};
export const Feature12DataSource = {
  wrapper: { className: 'home-page-wrapper content1-wrapper' },
  OverPack: { className: 'home-page content1', playScale: 0.3 },
  imgWrapper: { className: 'content1-img', md: 10, xs: 24 },
  img: {
    children:
      'https://cdn.staticaly.com/gh/powerli2002/project-img@main/图片3.a0hr7yp3ow4.png',
  },
  textWrapper: { className: 'content1-text', md: 14, xs: 24 },
  title: {
    className: 'content1-title',
    children: (
      <span>
        <p>A_star路径规划算法</p>
      </span>
    ),
  },
  content: {
    className: 'content1-content',
    children: (
      <span>
        <span>
          <p>
            利用栅格地图法<span>
              结合Dijkstra算法与BFS算法的优点，得到A*算法，通过评估得到最好的位置，从这个位置进行搜索直到目标。
            </span>
          </p>
          <p>
            我们将A星算法与slam激光雷达构建的地图数据进行对接调试，使用GMapping中的地图计算方式，突破传统A星算法基于已知固有的障碍地图进行路径规划，将激光雷达与栅格地图进行对接，实现激光雷达数据到栅格地图的一体化构建，提高了规划要求的精准度。
          </p>
        </span>
      </span>
    ),
  },
};
export const Contact01DataSource = {
  wrapper: {
    className: 'home-page-wrapper content10-wrapper le574i1azyf-editor_css',
  },
  Content: {
    className: 'icon-wrapper',
    children: {
      icon: {
        className: 'icon',
        children:
          'https://gw.alipayobjects.com/zos/rmsportal/zIUVomgdcKEKcnnQdOzw.svg',
        name: '主要图标',
      },
      iconShadow: {
        className: 'icon-shadow',
        children:
          'https://gw.alipayobjects.com/zos/rmsportal/WIePwurYppfVvDNASZRN.svg',
        name: '图标影阴',
      },
      url: { children: 'https://gaode.com/place/B01380183W', name: '跳转地址' },
      title: { children: '建模调研地址', name: '弹框标题' },
      content: {
        children: '保定国家高新技术产业开发区火炬产业园',
        name: '弹框内容',
      },
    },
  },
};
export const Footer00DataSource = {
  wrapper: { className: 'home-page-wrapper footer0-wrapper' },
  OverPack: { className: 'home-page footer0', playScale: 0.05 },
  copyright: {
    className: 'copyright',
    children: (
      <span>
        <span>
          <span>©2023 Lizijian&nbsp;All Rights Reserved</span>
        </span>
      </span>
    ),
  },
};
